import { render, staticRenderFns } from "./uploadOnly.vue?vue&type=template&id=3e20139c&scoped=true&"
import script from "./uploadOnly.vue?vue&type=script&lang=js&"
export * from "./uploadOnly.vue?vue&type=script&lang=js&"
import style0 from "./uploadOnly.vue?vue&type=style&index=0&id=3e20139c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20139c",
  null
  
)

export default component.exports